module.exports = __webpack_public_path__ + "img/84.5.COD.4cadb941.png";